import * as React from "react";
import type { SVGProps } from "react";
const SvgImageNoBorders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="m2.4 20.4-.78-.625A1 1 0 0 0 2.4 21.4zm5.28-6.6.78-.625a1 1 0 0 0-1.56 0zm1.92 2.4-.78.625a1 1 0 0 0 1.56 0zm4.32-5.4.78-.625a1 1 0 0 0-1.56 0zm7.68 9.6v1a1 1 0 0 0 .78-1.625zM8.4 5.4h-1a.8.8 0 0 1-.8.8v2a2.8 2.8 0 0 0 2.8-2.8zM6.6 7.2v-1a.8.8 0 0 1-.8-.8h-2a2.8 2.8 0 0 0 2.8 2.8zM4.8 5.4h1a.8.8 0 0 1 .8-.8v-2a2.8 2.8 0 0 0-2.8 2.8zm1.8-1.8v1a.8.8 0 0 1 .8.8h2a2.8 2.8 0 0 0-2.8-2.8zM2.4 20.4l.78.625 5.28-6.6-.78-.625-.78-.625-5.28 6.6zm5.28-6.6-.78.625 1.92 2.4.78-.625.78-.625-1.92-2.4zm1.92 2.4.78.625 4.32-5.4-.78-.625-.78-.625-4.32 5.4zm4.32-5.4-.78.625 7.68 9.6.78-.625.78-.625-7.68-9.6zm7.68 9.6v-1H2.4v2h19.2z"
    />
  </svg>
);
export default SvgImageNoBorders;
